import ReactStars from 'react-rating-stars-component';

export const CreateStarForFavoriteTrue = () => {
  const star = {
    size: 20,
    count: 1,
    value: 1,
    edit: false,
    color: 'green',
    activeColor: 'green',
    a11y: true,
    isHalf: true,
    emptyIcon: <i className="fa fa-star-o" />,
    halfIcon: <i className="fa fa-star-half-o" />,
    filledIcon: <i className="fa fa-star" />,
  };
  return <ReactStars {...star} />;
};

export const CreateStarForFavoriteFalse = () => {
  const star = {
    size: 20,
    count: 1,
    value: 0,
    edit: false,
    color: 'Grey',
    activeColor: 'Grey',
    a11y: true,
    isHalf: true,
    emptyIcon: <i className="fa fa-star-o" />,
    halfIcon: <i className="fa fa-star-half-o" />,
    filledIcon: <i className="fa fa-star" />,
  };
  return <ReactStars {...star} />;
};
